import { useTranslation } from 'react-i18next'
import { ParcelShop, ParcelShopService } from '@dhl/mdp-api'
import { Body1, Body2, Box, Card, Checkbox, Grid, H6 } from '@dhl-ui/components'
import { servicePointServices } from '~/modules/servicepoints/model'

type Props = {
  servicePoint: ParcelShop
}

export const ServicePointDetails = ({ servicePoint }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header title={t('admin.servicePointsPage.servicePointDetails.header')} />
      <Box m={1}>
        <Card.Content>
          <Box mb={2}>
            <H6>{t('admin.servicePointsPage.servicePointDetails.accountInformation')}</H6>
          </Box>
          <Grid direction="row" container spacing={1}>
            <Grid size={{ sm: 6 }}>
              <Body2 variant="tertiary">{t('admin.servicePointsPage.servicePointDetails.servicePoint')}</Body2>
              <Body1>{servicePoint.name}</Body1>
            </Grid>
            <Grid size={{ sm: 6 }}>
              <Body2 variant="tertiary">{t('admin.servicePointsPage.servicePointDetails.country')}</Body2>
              <Body1>{servicePoint.countryCode}</Body1>
            </Grid>
            <Grid size={{ sm: 6 }}>
              <Body2 variant="tertiary">{t('admin.servicePointsPage.servicePointDetails.servicePointKey')}</Body2>
              <Body1>{servicePoint.parcelShopPsfKey}</Body1>
            </Grid>
            <Grid size={{ sm: 6 }}>
              <Body2 variant="tertiary">{t('admin.servicePointsPage.servicePointDetails.debtorNumber')}</Body2>
              <Body1>{servicePoint.debtorNumber}</Body1>
            </Grid>
          </Grid>
          <Box mb={2} mt={3}>
            <H6>{t('admin.servicePointsPage.servicePointDetails.services')}</H6>
          </Box>
          <Box
            sx={{
              columnCount: 2,
              pt: 0.25,
              pr: 3,
            }}
          >
            {servicePointServices.map((service) => {
              const isSelected = servicePoint.services?.includes(service as unknown as ParcelShopService)
              return (
                <Box sx={{ mr: 1, mb: 1 }} key={service}>
                  <Checkbox disabled checked={isSelected} label={service} />
                </Box>
              )
            })}
          </Box>
        </Card.Content>
      </Box>
    </Card>
  )
}
